import { useScrollTrigger } from '@mui/material';
import Fade from '@mui/material/Fade';
import PropTypes from 'prop-types';
import MDBox from 'components/MDBox';

ScrollTop.propTypes = {
  topSelector: PropTypes.string,
  children: PropTypes.element.isRequired
};

export default function ScrollTop({ topSelector, children }) {
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window,
    disableHysteresis: true,
    threshold: 100
  });

  const handleClick = (event) => {
    if (topSelector) {
      const anchor = (event.target.ownerDocument || document).querySelector(topSelector);

      if (anchor) {
        anchor.scrollIntoView({
          block: 'center'
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  };

  return (
    <Fade in={trigger}>
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="3.25rem"
        height="3.25rem"
        bgColor="white"
        shadow="sm"
        borderRadius="50%"
        position="fixed"
        right="2rem"
        bottom="6rem"
        zIndex={99}
        color="dark"
        sx={{ cursor: 'pointer' }}
        onClick={handleClick}
      >
        {children}
      </MDBox>
    </Fade>
  );
}
